import { render, staticRenderFns } from "./CourierDetailPopup.vue?vue&type=template&id=4a8d5e73&scoped=true"
import script from "./CourierDetailPopup.vue?vue&type=script&lang=js"
export * from "./CourierDetailPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8d5e73",
  null
  
)

export default component.exports